export const depoNome1 = 'M.B.';

export const depoNome2 = 'I.P.C.'

export const depoNome3 = 'L.E.'

export const depoNome4 = 'A.L.R.'